import { notifyPdfLoadedSection } from '../PDFRenderer/PDFRendererActions';
import { PdfSectionType } from '../PDFRenderer/PDFRendererTypes';
import fetchWithDefaults from '../CommonUtils/fetchWithDefaults';
import { urlWithParams } from '../CommonUtils/urlWithParams';
import { HttpError } from '../errors/HttpError';
import { httpBodyOptions } from '../CommonUtils/httpBodyOptions';

const prefixer = name => `ADV.MONTE_CARLO_CHART.${name}`;

export const REQUEST_DATA = prefixer('REQUEST_DATA');
export const RECEIVE_DATA = prefixer('RECEIVE_DATA');
export const INVALIDATE_CACHE = prefixer('INVALIDATE_CACHE');
export const STAGE_WHAT_IFS = prefixer('STAGE_WHAT_IFS');
export const SET_UPDATE_CACHE_DATA = prefixer('SET_UPDATE_CACHE_DATA');

export const FAILED_TO_RECEIVE_DATA = prefixer('FAILED_TO_RECEIVE_DATA');

export const requestData = (clientId, requestedWith) => ({
  type: REQUEST_DATA,
  clientId,
  requestedWith,
});

export const receiveData = (clientId, data) => ({
  type: RECEIVE_DATA,
  clientId,
  data,
});
export const stageWhatIfs = (clientId, whatIfs) => ({
  type: STAGE_WHAT_IFS,
  clientId,
  whatIfs,
});

export const invalidateCache = clientId => ({
  type: INVALIDATE_CACHE,
  clientId,
});

export const setUpdateCacheData = (clientId, updateCacheData) => ({
  type: SET_UPDATE_CACHE_DATA,
  clientId,
  updateCacheData,
});

export const failedToReceiveData = clientId => ({
  type: FAILED_TO_RECEIVE_DATA,
  clientId,
});

export const fetchMcData = (fpId, clientId) => async dispatch => {
  const requestedWith = {
    clientId,
    fpId,
    stagedWhatIfs: [],
  };

  dispatch(requestData(clientId, requestedWith));

  try {
    const response = await fetchWithDefaults(urlWithParams('/Consumer/MC', requestedWith));

    if (response.ok) {
      const { payload, success } = await response.json();

      if (success) {
        dispatch(receiveData(clientId, payload.viewData));
        dispatch(notifyPdfLoadedSection(PdfSectionType.RetirementMonteCarlo));
        return;
      }

      throw new Error('Response status is not success.');
    }

    throw new HttpError(response);
  } catch (err) {
    dispatch(failedToReceiveData(clientId));
    console.error(err); // eslint-disable-line no-console
  }
};

export const fetchPostMcData = (
  fpId,
  clientId,
  isPdf,
  stagedWhatIfs,
  FRAOption,
) => async dispatch => {
  const requestedWith = {
    clientId,
    IsPdf: isPdf,
    fpId,
  };

  dispatch(requestData(clientId, { ...requestedWith, stagedWhatIfs }));

  const body = Array.isArray(stagedWhatIfs)
    ? [{ ...stagedWhatIfs[0], ...FRAOption }]
    : [{ ...stagedWhatIfs, ...FRAOption }];

  try {
    const response = await fetchWithDefaults(urlWithParams('/Consumer/MC', requestedWith), {
      method: 'POST',
      ...httpBodyOptions(body, true),
    });

    if (response.ok) {
      const { payload, success } = await response.json();

      if (success) {
        dispatch(receiveData(clientId, payload.viewData));
        return;
      }

      throw new Error('Response status is not success.');
    }

    throw new HttpError(response);
  } catch (err) {
    dispatch(failedToReceiveData(clientId));
    console.error(err.toString()); // eslint-disable-line no-console
  }
};
